var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolFreehandRoi = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3 2c8 3 5 8.5 2 15.5S6.5 25 8 25a4.38 4.38 0 0 0 3-1M24.38 14.619l-7.63 7.631L13 23l.75-3.75 7.63-7.631a2.116 2.116 0 0 1 2.992 0l.008.009a2.113 2.113 0 0 1 0 2.991"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.654 19.296 3.059 2.684"
})))));
export { SvgToolFreehandRoi as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-freehand-roi.svg";